<template>
  <b-form-group
    v-if="!hideLabel"
    v-bind="calcAttrs"
    v-on="$listeners"
    :state="state"
    :invalid-feedback="fieldErrors"
  >
    <template #label>
      {{ label }} <span v-if="required" class="text-danger"> *</span></template
    >
    <slot />
  </b-form-group>
  <span v-else>
    <slot />
  </span>
</template>

<script>
const VerticalFormGroup = {
  "label-cols-sm": "12",
  "content-cols-sm": "12",
  "label-cols-md": "12",
  "content-cols-md": "12",
  "label-cols-lg": "12",
  "content-cols-lg": "12",
  "label-cols-xl": "12",
  "content-cols-xl": "12",
};

const HorizontalFormGroup = {
  "label-cols-sm": "12",
  "content-cols-sm": "12",
  "label-cols-md": "3",
  "content-cols-md": "9",
  "label-cols-lg": "3",
  "content-cols-lg": "9",
  "label-cols-xl": "3",
  "content-cols-xl": "9",
};
export default {
  name: "FFormGroup",
  props: {
    hideLabel: { type: Boolean, default: false },
    horizontal: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    label: { type: String, default: "" },
    fieldErrors: {},
  },
  computed: {
    state() {
      return this.fieldErrors === null;
    },
    calcAttrs() {
      var result = { ...this.$attrs };
      var cols = HorizontalFormGroup;

      if (!this.horizontal) {
        cols = VerticalFormGroup;
      }

      if ("labelCols" in this.$attrs) {
        // this the columns speified instead!
        cols = {
          "label-cols-sm": this.$attrs.labelCols,
          "content-cols-sm": "",
          "label-cols-md": this.$attrs.labelCols,
          "content-cols-md": "",
          "label-cols-lg": this.$attrs.labelCols,
          "content-cols-lg": "",
          "label-cols-xl": this.$attrs.labelCols,
          "content-cols-xl": "",
        };
      }
      return { ...cols, ...result };
    },
  },
};
</script>

<style scoped></style>
